import type { PartnerEnum } from '../groveSchedulerClient'
import type { PartnerSchemaInternal } from './types'

/**
 * Denticon partner configuration schema
 * Requires client_id, client_secret, and optional office_ids (array of strings,
 * stored as a DynamoDB StringSet on the grove-scheduler side).
 * No OAuth flow — credentials are API-key style, consumed by the sync service.
 */
export const denticonSchema: PartnerSchemaInternal = {
  partner: 'denticon' as PartnerEnum,
  displayName: 'Denticon',
  fields: [
    {
      key: 'client_id',
      label: 'Client ID',
      type: 'text',
      required: true,
    },
    {
      key: 'client_secret',
      label: 'Client Secret',
      type: 'text',
      required: true,
    },
    {
      key: 'office_ids',
      label: 'Office IDs',
      type: 'list',
      required: false,
      itemType: 'string',
      helperText: 'Denticon office identifiers. Add one at a time.',
    },
  ],
}
